/********************************************************* {COPYRIGHT-TOP} ***
 * Licensed Materials - Property of IBM
 *
 * (C) Copyright IBM Corporation 2016, 2024
 *
 * All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 ********************************************************** {COPYRIGHT-END} **/

import React, { useEffect, useState } from 'react';
import { TextInput } from '@carbon/react';
import { useTranslation } from 'react-i18next';

const TestToolVapidAuth = ({ vapidCreds, onChange }) => {
  const { t } = useTranslation();
  const [vapidJSONWebToken, setVapidJSONWebToken] = useState('');
  const [vapidJSONWebKey, setVapidJSONWebKey] = useState('');

  useEffect(() => {
    setVapidJSONWebToken(vapidCreds.vapidJSONWebToken ?? '');
    setVapidJSONWebKey(vapidCreds.vapidJSONWebKey ?? '');
  }, [vapidCreds]);

  const handleHttpVapidJSONWebTokenChange = (event) => {
    const vapidJSONWebToken = event.target.value;
    setVapidJSONWebToken(vapidJSONWebToken);
    if (onChange && typeof onChange === 'function') {
      onChange({ vapidJSONWebKey, vapidJSONWebToken });
    }
  };

  const handleHttpVapidJSONWebKeyChange = (event) => {
    const vapidJSONWebKey = event.target.value;
    setVapidJSONWebKey(event.target.value);
    if (onChange && typeof onChange === 'function') {
      onChange({ vapidJSONWebKey, vapidJSONWebToken });
    }
  };

  return (
    <div className="testToolVapidAuth">
      <div className="vapidjsonwebtoken">
        <div className="labelText">{t('json_web_token')}</div>
        <TextInput id="vapidjsonwebtoken" hideLabel labelText={t('json_web_token')} value={vapidJSONWebToken} onChange={handleHttpVapidJSONWebTokenChange} />
      </div>

      <div className="vapidjsonwebkey">
        <div className="labelText">{t('json_web_key')}</div>
        <TextInput id="vapidjsonwebkey" labelText={t('json_web_key')} hideLabel value={vapidJSONWebKey} onChange={handleHttpVapidJSONWebKeyChange} />
      </div>
    </div>
  );
};

export default TestToolVapidAuth;
